export enum ContractProjectFinancial {
    CustomerAnalysis = 1, 
    JudiciaryAnalysis = 2, 
    SignerContract = 3, 
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractProjectFinancial.ts